import { gql } from '@apollo/client';

import { DataRefreshMetaFieldsFragment } from './fragments';

export const GET_EVENT_REFRESH_DATA = gql`
  query GetEventDataRefresh($schemaId: ID!) {
    eventRefreshMeta(schemaId: $schemaId) {
      ...DataRefreshMetaFields
    }
  }
  ${DataRefreshMetaFieldsFragment}
`;

export const GET_FIELD_REFRESH_DATA = gql`
  query GetFieldDataRefresh($schemaId: ID!, $fieldKey: String!) {
    fieldRefreshMeta(schemaId: $schemaId, fieldKey: $fieldKey) {
      ...DataRefreshMetaFields
    }
  }
  ${DataRefreshMetaFieldsFragment}
`;
